import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Skeleton, TablePagination, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import './stockReceive.scss'
// import api from '../../api/api'
import dayjs from 'dayjs'
// import StockContext from './services/stockApi'
import { getBranchList } from '../setting/services/settingApi'
import { useSelector } from 'react-redux'
import { getData } from '../../services/api'
import { STOCK_CONFIG } from './config'
export default function StockReceive() {
    const [branchs, setBranchs] = useState([])
    const [loading, setLoading] = useState(false)

    const { profile } = useSelector(state => state.profile)

    // const { getReceivesList } = useContext(StockContext);

    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    // const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const getReceivesList = async () => {
        setLoading(true)
        let _params = `${q ? '&receiveNo=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}`

        await getData(STOCK_CONFIG.requests.getReceives.url + `?page=${page}&limit=${rowsPerPage}`, _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    useEffect(() => {
        getBranchList(null, setBranchs)
    }, [])
    useEffect(() => {
        getReceivesList()
    }, [b, q, page])
    return (
        <Page>
            <div class="container-fluid">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0px' }}>
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการรับเมล็ดพันธุ์ดี
                        </label>
                    </div>
                    <div class="col-lg-8 col-md-12 text-left " style={{ display: 'flex', justifyContent: 'end' }}>

                        <div class="col-lg-3 col-md-12 text-end px-4">
                            <Link to='/stock/stock-receive/add'>
                                <Button className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                            </Link>
                        </div >
                        {
                            profile?.BranchNo?.BranchNo === '00' &&
                            <div class="col-lg-2 col-md-12 ">
                                <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={b || 'all'} onChange={e => setSearchParams({ q: q, b: e.target.value })} 
                                        disableUnderline
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                        >
                                            <MenuItem value='all'>ทั้งหมด</MenuItem>

                                            {branchs?.map((x, i) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div >
                        }
                        <div class="col-lg-3 col-md-12">
                            <Box className='backgroundField'>
                                <TextField variant="standard" value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                    InputProps={{
                                        disableUnderline: true,
                                        startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </div >
                <div class="stockReceive  row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ที่</th>
                                        <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                        <th class="text-center">วันที่เอกสาร</th>
                                        <th class="text-center">เลขที่เอกสาร</th>
                                        <th class="text-center"> เลขที่อ้างอิง</th>
                                        <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                        <th class="text-center">สถานะ</th>
                                        <th class="text-center">ดำเนินการ</th>
                                    </tr>
                                </thead>
                                <tbody class="">
                                    {data?.items?.map((x, i) => (
                                        <tr className={id === x?.ReceiveNo ? 'active' : ''}>
                                            <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                            <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                            <td class="text-center">{dayjs(x?.ReceiveDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center">{x?.ReceiveNo}</td>
                                            <td class="text-center">{x?.RefNo}</td>
                                            <td class="text-center">{x?.TotalQty.toLocaleString()}</td>
                                            <td class="text-center">
                                                {x?.Status === 'C' ? <span class="status-draft">
                                                    ปิด
                                                </span> :
                                                    x?.Status === 'Y' ?
                                                        <span class="status-active">
                                                            เสร็จสิ้น
                                                        </span> : x?.Status === 'N' ?
                                                            <span class="status-inactive">
                                                                ยกเลิก
                                                            </span> : ''}

                                            </td>
                                            <td class="text-center">
                                                <Link to={`/stock/stock-receive/${x?.ReceiveNo}`} onClick={() => setSearchParams({ id: x?.ReceiveNo, page: page, q: q, b: b })}>
                                                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                                </Link>
                                            </td>
                                        </tr >
                                    ))}

                                </tbody >
                            </table >
                        </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, b: b, id: id })} shape="rounded" />
                    </div>
                </div >
            </div >

        </Page>

    )
}
